export default "__VITE_ASSET__BrC5XDUF__"